<template>
<div class="chapter">
<div class="inner_page">
<img src="MUTTS_Spring_FXL7.html.jpg" style="margin-left: 0px;"/>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MUTTS_Spring_FXL7.vue?4e68da4f